import React, {FC, useEffect, useState} from 'react'
import {observer} from 'mobx-react'
import useStore from 'store'
import {FeatureIds, ModuleEnum, ModuleType, ProviderEnum} from 'utils/types'
import {useTranslation} from 'react-i18next'
import {Space, Row, Icon, Text, theme} from '../../ui'
import { Switch } from '@material-ui/core'
import {
    ModalRow,
    ModalText,
    ConfirmButtonSm,
    DeleteButtonSm,
    ButtonGroup,
    DialogHeaderText,
    ToggleGroup,
    ToggleRow
} from './styles'


export interface CouponFormState {
    isEnable: boolean
}

interface CouponSectionProps {
    currentOrgId: number | undefined
    resetForm: boolean
}


const CouponSection: FC<CouponSectionProps> = ({ currentOrgId, resetForm }) => {
    const {modulesStore, orgs: orgsStore} = useStore()
    const {t} = useTranslation('communitySettings')

    const [isFormChanged, setIsFormChanged] = useState<boolean>(false)
    const [module, setModule] = useState<any>(null)
    const [formState, setFormState] = useState<CouponFormState>({
        isEnable: false
    }) 

    useEffect(() => {
        const couponModule = modulesStore.communityFeatures.find(el => el.featureName === 'Coupon')
        if (couponModule) {
            setModule(couponModule)
            setFormState({ isEnable: couponModule.enabled })
        } else {
            orgsStore.updateCommunity(currentOrgId, [...modulesStore.communityFeatures, {
                communityId: currentOrgId,
                enabled: false,
                featureName: 'Coupon',
                id: FeatureIds.COUPONS,
                status: 2,
            }]).then(async (res) => {
                await modulesStore.getCommunityModulesAndFeatures(currentOrgId)
                const newCouponModule = modulesStore.communityFeatures.find(el => el.featureName === 'Coupon')
                if (newCouponModule) {
                    setModule(newCouponModule)
                    setFormState({ isEnable: newCouponModule.enabled })
                }
            })
        }
    }, [currentOrgId])

    useEffect(() => {
        if (resetForm) onResetForm()
    }, [resetForm])

    useEffect(() => {
        setIsFormChanged(
            formState.isEnable !== (module?.enabled ?? false)
        )
    }, [formState, module])


    const Save = async () => {
        if (currentOrgId) {
            await orgsStore.updateCommunity(currentOrgId,
                modulesStore.communityFeatures.map(el => el.featureName === 'Coupon' ? {
                    communityId: el.communityId,
                    enabled: formState.isEnable,
                    featureName: el.featureName,
                    id: el.id,
                    status: formState.isEnable ? 1 : 2,
                } : el),)

            await modulesStore.getCommunityModulesAndFeatures(currentOrgId)
            
            const couponModule = modulesStore.communityFeatures.find(el => el.featureName === 'Coupon')
            if (couponModule) {
              setModule(couponModule)
              setFormState({ isEnable: couponModule.enabled })
            }
        }        
    }
    
    const onResetForm = () => setFormState({
        isEnable: false
    })

    const ToggleEnable = (value: any) => setFormState({...formState, isEnable: value })

    return (
        <>
            <ModalRow>
               <DialogHeaderText>{t`couponTab`}</DialogHeaderText>
               <ButtonGroup>
                 <ConfirmButtonSm disabled={!isFormChanged || module == null} onClick={Save} transparent>{t`save`}</ConfirmButtonSm>
               </ButtonGroup>
            </ModalRow>

            {module &&
                <ToggleGroup>
                    <ToggleRow>
                        <ModalText>{t`isEnable`}:</ModalText>
                        <Switch
                            color="primary"
                            value={formState.isEnable}
                            onChange={({target}) => {
                                ToggleEnable(target.checked)
                            }}
                            checked={formState.isEnable}
                        />
                    </ToggleRow>
                </ToggleGroup>
            }
            <Space/>
            <Space/>
        </>
    )
}

export default observer(CouponSection)